import { BarModule as BarModuleStruct, BarModuleState } from '@/Store/interfaces/bar';

const BarModule: BarModuleStruct = {
  state: {
    barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
    barImage: 'https://demos.creative-tim.com/material-dashboard-pro/assets/img/sidebar-1.jpg',
  },
  mutations: {
    SET_BAR_IMAGE(state: BarModuleState, payload: string): void {
      state.barImage = payload
    },
    SET_SCRIM(state: BarModuleState, payload: string): void {
      state.barColor = payload
    },
  },
}

export default BarModule
